import { React, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import chatus_bg from '../images/liaison/Chatus-bg-1.png'
import Button from '../Components/Button'

function Chatwithus() {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
            {/* Chat with us  */}
            <div className="max-w-[1550px] mx-auto xl:flex flex-wrap font-[lato]" data-aos="fade-up">
                <img className="sm:w-[800px] sm:h-[900px] min-[1280]:mx-auto" src={chatus_bg} alt="bg" />

                <div className="max-w-[320px] font-alibaba text-center mx-auto my-14 xl:text-left xl:ml-20 xl:my-auto" data-aos="fade-up" data-aos-duration="700">
                    <h3 className="text-[19px] mb-2">Customer Support</h3>
                    <hr className='border-yellow border-[1.5px] w-[87px] mx-auto lg:mx-0' />

                    <h2 className="font-noto text-[32px] font-bold sm:leading-[48px] my-4 sm:text-[40px]" data-aos="fade-up" data-aos-duration="700">Your questions <br /> answered ?</h2>
                    <p className="text-[#575857] text-[16px] leading-[22px] mt-[16px] mb-[45px]" data-aos="fade-up" data-aos-duration="700">Reach out anytime. We’re available by phone, email, or through chat.</p>
                    
                    <Button
                        name={"Chat Now"}
                        design={"filled"}
                        action={"external-linking"}
                        url={`https://wa.me/8925837928?text=Hello!`}
                    />
                </div>
            </div>
        </>
    );
}

export default Chatwithus;
